// import React, { useState, useEffect, useRef } from "react";
// import { Modal, message, Button } from "antd";
// import LoadingBox from "../../Components/LoadingBox";
// import { Table, Col, Row, Container } from "react-bootstrap";
// import { API, Headers } from "../../Config";
// import axios from "axios";
// import moment from "moment";
// import logo from "../../Assets/Images/logoNew.jpg";
// import Barcode from "react-barcode";
// import ReactToPrint from "react-to-print";
// import GenQrCode from "./GenQrCode";
// import "./style.css";
// import Companyseal from "../../Assets/Images/seal.JPG";

// function PrintCustomerInvoiceModal2(props) {
//   const [loading, setLoading] = useState(false);
//   const [boxItems, setBoxItems] = useState([]);
//   const componentRef = useRef();

//   useEffect(() => {
//     loadDetails();
//   }, []);

//   const loadDetails = () => {
//     setBoxItems(props.item.boxe_item);
//     console.log(props.item);
//   };

//   console.log(props.item);

//   const medianBoxNum = Math.floor(boxItems && boxItems.length / 2);

//   let requestData = {
//     is_customer_invoice_print: true,
//   };
//   const isPrinted = () => {
//     axios({
//       method: "put",
//       url:
//         API.BASR_URL +
//         API.BOXES_ACTIONS +
//         "print/" +
//         props.item.box_number +
//         "/is_customer_invoice_print",
//       headers: Headers(),
//       data: requestData,
//     })
//       .then(function (response) {
//         setLoading(false);
//         if ([200, 201].includes(response.status)) {
//           message.success("Success");
//           props.onClose();
//           props.reload();
//         }
//       })
//       .catch(function (error) {
//         setLoading(false);
//         message.error("Oops.Something went wrong");
//         console.log(error);
//       });
//   };

//   return (
//     <Modal
//       visible={props.visible}
//       onOk={() => props.onClose()}
//       onCancel={() => props.onClose()}
//       width={900}
//       footer={null}
//     >
//       {loading ? (
//         <LoadingBox />
//       ) : (
//         <div>
//           <div ref={componentRef}>
//             <div className="print-invoice-page">
//               <table className="print-invoice-table">
//                 <tr>
//                   <td colSpan={2}>
//                     <img src={logo} width="" className="InvoiceLogo" />
//                   </td>
//                   <td></td>
//                   <td colSpan={2}>
//                     <div className="print-invoice-table-headertxt">
//                       <div
//                         className="print-invoice-table-headertxt1"
//                         style={{ fontSize: "10px", textTransform: "uppercase" }}
//                       >
//                         HO:
//                         {props.item.created_user &&
//                         props.item.created_user.branch
//                           ? `${
//                               (props.item.created_user.branch?.name,
//                               props.item.created_user.branch?.office_address)
//                             }`
//                           : null}
//                       </div>
//                       <div
//                         className="print-invoice-table-headertxt1"
//                         style={{ fontSize: "10px" }}
//                       >
//                         PH:
//                         {props.item.created_user &&
//                         props.item.created_user.branch
//                           ? `${props.item.created_user.branch?.mobile}`
//                           : null}
//                       </div>
//                       <div
//                         className="print-invoice-table-headertxt1"
//                         style={{ fontSize: "10px" }}
//                       >
//                         VAT NO: 300602378400003
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan={5}>
//                     <div className="print-invoice-txt4">CUSTOMER INVOICE</div>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan={3}>
//                     <div className="print-invoice-txt1">SENDER INFO</div>
//                     <div className="print-invoice-txt2">
//                       {props.item.collection &&
//                         props.item.collection.sender_name}
//                     </div>
//                     <div className="print-invoice-txt2">
//                       {props.item.collection &&
//                         props.item.collection.sender_address}
//                     </div>
//                     <div className="print-invoice-txt2">
//                       {props.item.collection &&
//                         props.item.collection.sender_phone}
//                     </div>
//                     <hr />
//                     <div className="print-invoice-txt1">RECIEVER INFO</div>
//                     <div className="print-invoice-txt2">
//                       {props.item.collection &&
//                         props.item.collection.reciver_name}
//                     </div>

//                     <div className="print-invoice-txt2">
//                       {props.item.collection &&
//                         props.item.collection.reciver_address}
//                     </div>
//                     <div className="print-invoice-txt2">
//                       {props.item.collection &&
//                         props.item.collection.reciver_phone}
//                       ,
//                       {props.item.collection &&
//                         props.item.collection.reciver_altphone}
//                     </div>
//                     <div className="print-invoice-txt2">
//                       {props.item.collection &&
//                         props.item.collection.reciver_pincode}
//                       ,{""}
//                       {props.item.collection &&
//                         props.item.collection.reciver_city}
//                       <div className="print-invoices-text3">
//                         {props.item.collection?.reciver_post &&
//                           props.item.collection?.reciver_post}
//                       </div>
//                     </div>
//                     <div className="print-invoice-txt2">
//                       {props.item.collection &&
//                         props.item.collection.reciver_distrcit}
//                       ,{""}
//                       {props.item.collection &&
//                         props.item.collection.reciver_state}
//                       ,
//                       {props.item.collection &&
//                         props.item.collection.recivercountries &&
//                         props.item.collection.recivercountries.name}
//                     </div>
//                   </td>
//                   <td colSpan={2}>
//                     <div className="print-invoice-txt3">
//                       INVOICE NO:<strong>INV{moment().unix()}</strong>
//                     </div>

//                     <div className="print-invoice-txt3">
//                       INVOICE DATE:
//                       <strong>
//                         {props.item?.createdAt &&
//                           moment(props.item?.createdAt).format("DD-MM-YYYY")}
//                       </strong>
//                     </div>

//                     <div className="print-invoice-txt3">
//                       BOOKED STAFF:{" "}
//                       <strong>
//                         {props.item.created_user &&
//                           props.item.created_user.name}
//                       </strong>
//                     </div>
//                     <div className="print-invoice-txt3">
//                       BOOKED BRANCH:{" "}
//                       <strong>
//                         {props.item.created_user &&
//                           props.item.created_user.branch &&
//                           props.item.created_user.branch.name}
//                       </strong>
//                     </div>

//                     <div className="print-invoice-txt3">
//                       BOOKED DATE:
//                       <strong>
//                         {props.item?.createdAt &&
//                           moment(props.item?.createdAt).format("DD-MM-YYYY")}
//                       </strong>
//                     </div>

//                     <div
//                       className="print-invoice-txt3"
//                       style={{ background: "#f2f2f2" }}
//                     >
//                       REFRENCE:{" "}
//                       <strong>
//                         {props.item.box_ref_no
//                           ? props.item.box_ref_no
//                           : props.item.referance_details
//                           ? props.item.referance_details
//                           : ""}
//                       </strong>
//                     </div>
//                     <div className="print-invoice-txt3">
//                       BOX SIZE:{" "}
//                       <strong>
//                         {props.item.boxType && props.item.boxType.name}{" "}
//                         {props.item &&
//                           `${props.item.length} x ${props.item.breadth} x ${props.item.height}`}
//                       </strong>
//                     </div>

//                     <div className="print-invoice-txt3">
//                       CHARGABLE WEIGHT:{" "}
//                       <strong>
//                         {props.item && props.item.chargable_weight}
//                       </strong>
//                     </div>

//                     <div className="print-invoice-txt3">
//                       RATE PER KILO:{" "}
//                       <strong>{props.item && props.item.rate}</strong>
//                     </div>

//                     <div className="print-invoice-txt3">
//                       PACKING CHARGE:{" "}
//                       <strong>{props.item && props.item.packing_charge}</strong>
//                     </div>

//                     <div className="print-invoice-txt3">
//                       DUTY: <strong>{props.item && props.item.duty}</strong>
//                     </div>

//                     <div className="print-invoice-txt3">
//                       OTHER:{" "}
//                       <strong>{props.item && props.item.other_charges}</strong>
//                     </div>

//                     <div className="print-invoice-txt3">
//                       AMOUNT:{" "}
//                       <strong>{props.item && props.item.total_charge}</strong>
//                     </div>
//                     <div className="print-invoice-txt3">
//                       VAT: <strong>0</strong>
//                     </div>
//                     <div className="print-invoice-txt3">
//                       TOTAL:{" "}
//                       <strong>{props.item && props.item.total_charge}</strong>
//                     </div>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan={5}>
//                     <hr />
//                   </td>
//                 </tr>

//                 <tr>
//                   <td colSpan={2}>
//                     <Barcode
//                       value={props.item && props.item.box_number}
//                       height="60"
//                       fontSize="12px"
//                       font="Montserrat-Regular"
//                     />
//                   </td>

//                   <td colSpan={1}>
//                     <div
//                       className="service"
//                       style={{
//                         fontSize: "28px",
//                         fontStyle: "bold",
//                         fontWeight: "800",
//                         fontFamily: "Poppins-Bold",
//                       }}
//                     >
//                       {props.item.service &&
//                         props.item.service.name &&
//                         props.item.service.name}
//                     </div>
//                   </td>

//                   <td colSpan={1}>
//                     <div
//                       className="bordered"
//                       style={{
//                         textAlign: "flex-end",
//                         border: "none",
//                       }}
//                     >
//                       <GenQrCode item={props.item} />
//                     </div>
//                   </td>

//                   <td colSpan={1}>
//                     <div
//                       className="bordered"
//                       style={{
//                         textAlign: "flex-end",
//                         border: "none",
//                       }}
//                     >
//                       <div className="text2">
//                         Booking No:{" "}
//                         <b>{props.item && props?.item?.collection_id}</b>
//                       </div>
//                       <div className="text2">
//                         Total Pcs:{" "}
//                         <b>
//                           {/* {props?.data && props?.data?.collection?.sender_name} */}
//                           {props.item && props?.item?.collection?.boxes?.length}
//                         </b>
//                       </div>

//                       {props.item && props?.item?.box_ref_no !== "" ? (
//                         <div className="text2">
//                           Ref No: <b>{props.item && props?.item?.box_ref_no}</b>
//                         </div>
//                       ) : null}
//                     </div>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan={5}>
//                     <div className="print-invoice-txt4">PACKING LIST</div>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan={5}>
//                     <div className="print-invoice-table-row">
//                       <div className="print-invoice-table-column">
//                         <table className="print-invoice-table">
//                           <tr>
//                             <th className="print-invoice-table-td" colSpan={1}>
//                               <div className="print-customsInvoice-txt5">
//                                 S No
//                               </div>
//                             </th>
//                             <th className="print-invoice-table-td" colSpan={2}>
//                               <div className="print-customsInvoice-txt5">
//                                 Items Name
//                               </div>
//                             </th>
//                             <th className="print-invoice-table-td" colSpan={1}>
//                               <div className="print-customsInvoice-txt5">
//                                 Qty
//                               </div>
//                             </th>
//                           </tr>
//                           {boxItems &&
//                             boxItems.slice(0, 10).map((items, index) => {
//                               return (
//                                 <tr key={index}>
//                                   <td
//                                     className="print-invoice-table-td"
//                                     colSpan={1}
//                                   >
//                                     <div className="print-customsInvoice-txt6">
//                                       {index + 1}
//                                     </div>
//                                   </td>
//                                   <td
//                                     className="print-invoice-table-td"
//                                     colSpan={2}
//                                   >
//                                     <div className="print-customsInvoice-txt6">
//                                       {items.item}
//                                     </div>
//                                   </td>
//                                   <td
//                                     className="print-invoice-table-td"
//                                     colSpan={1}
//                                   >
//                                     <div className="print-customsInvoice-txt6">
//                                       {items.quantity}
//                                     </div>
//                                   </td>
//                                 </tr>
//                               );
//                             })}
//                         </table>
//                       </div>
//                       <div className="print-invoice-table-column">
//                         <table className="print-invoice-table">
//                           <tr>
//                             <th className="print-invoice-table-td" colSpan={1}>
//                               <div className="print-customsInvoice-txt5">
//                                 S No
//                               </div>
//                             </th>
//                             <th className="print-invoice-table-td" colSpan={2}>
//                               <div className="print-customsInvoice-txt5">
//                                 Items Name
//                               </div>
//                             </th>
//                             <th className="print-invoice-table-td" colSpan={1}>
//                               <div className="print-customsInvoice-txt5">
//                                 Qty
//                               </div>
//                             </th>
//                           </tr>
//                           {boxItems &&
//                             boxItems.slice(10, 20).map((items, index) => {
//                               return (
//                                 <tr key={index}>
//                                   <td
//                                     className="print-invoice-table-td"
//                                     colSpan={1}
//                                   >
//                                     <div className="print-customsInvoice-txt6">
//                                       {index + 11}
//                                     </div>
//                                   </td>
//                                   <td
//                                     className="print-invoice-table-td"
//                                     colSpan={2}
//                                   >
//                                     <div className="print-customsInvoice-txt6">
//                                       {items.item}
//                                     </div>
//                                   </td>
//                                   <td
//                                     className="print-invoice-table-td"
//                                     colSpan={1}
//                                   >
//                                     <div className="print-customsInvoice-txt6">
//                                       {items.quantity}
//                                     </div>
//                                   </td>
//                                 </tr>
//                               );
//                             })}
//                         </table>
//                       </div>
//                     </div>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan={5}>
//                     <div className="print-invoice-txt5">
//                       1. I.Mr/Mrs{" "}
//                       <strong className="print-customsInvoice-txt7">
//                         {props.item.collection &&
//                           props.item.collection.sender_name}
//                       </strong>{" "}
//                       for my family/friends, personal use as gift.not for sale.
//                       Shipper also declare that he is liable of any customs
//                       duty/fine / penalites against this shipment at origin and
//                       destination
//                     </div>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan={5}>
//                     <div className="print-invoice-txt5">
//                       2. Shipper certifies that the particulars on the face here
//                       of are correct and that insofar as any part of the
//                       consignemt contains Dangerous Goods if any surch part is
//                       property by name and is in proper condition for carriage
//                       by air according to the Internation Transport
//                       Association's applicable dangerous goods regulations and
//                       civil Aviation Regulation of the United Arab Emirates.
//                     </div>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan={5}>
//                     <div className="print-invoice-txt5">
//                       3. I/We agree that standard terms and conditions apply for
//                       this shipment and liability to terms and conditions.
//                       Warsaw Convention amy apply. I/We Service Liability shall
//                       not exceed US$100 for any shipment.
//                     </div>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan={5}>
//                     <div className="print-invoice-txt5">
//                       4. /The Shipper also here by authorize forward the
//                       shipment in full or part their convenience
//                     </div>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan={5}>
//                     <div className="print-invoice-txt5">
//                       5. The Shipper also here by authorize and their
//                       Counterpart India to clear the parcel on behalf of me and
//                       same should be delivered to the Consignee address.
//                     </div>
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan={2} className="print-invoice-txt1">
//                     Sender Signature{" "}
//                   </td>
//                   <td colSpan={1}></td>
//                   <td colSpan={2} className="print-invoice-txt1">
//                     For Sahari International courier
//                   </td>
//                 </tr>
//                 <tr>
//                   <td colSpan={2}>
//                     {props.item.signature ? (
//                       <div>
//                         <img
//                           src={props.item.signature}
//                           className="print-invoice-signature"
//                         />
//                       </div>
//                     ) : null}
//                   </td>
//                   <td colSpan={1}></td>
//                   <td colSpan={2}>
//                     <div
//                       className="print-customs-seal"
//                       style={{
//                         display: "flex",
//                       }}
//                     >
//                       <img src={Companyseal} height="100%" width="100%" />
//                       {props.item.collection &&
//                       props.item.collection.driver_signature ? (
//                         <img
//                           src={
//                             props.item.collection &&
//                             props.item.collection.driver_signature
//                           }
//                           className="print-invoice-signature"
//                         />
//                       ) : null}
//                     </div>
//                   </td>
//                 </tr>
//               </table>
//             </div>
//             {medianBoxNum >= 11 ? (
//               <div style={{ padding: 10 }}>
//                 <br />
//                 <div className="print-invoice-table-row">
//                   <div className="print-invoice-table-column">
//                     <table className="print-invoice-table">
//                       <tr>
//                         <th className="print-invoice-table-td" colSpan={1}>
//                           <div className="print-customsInvoice-txt5">S No</div>
//                         </th>
//                         <th className="print-invoice-table-td" colSpan={2}>
//                           <div className="print-customsInvoice-txt5">
//                             Items Name
//                           </div>
//                         </th>
//                         <th className="print-invoice-table-td" colSpan={1}>
//                           <div className="print-customsInvoice-txt5">Qty</div>
//                         </th>
//                       </tr>
//                       {boxItems &&
//                         boxItems.slice(20).map((items, index) => {
//                           return (
//                             <tr key={index}>
//                               <td
//                                 className="print-invoice-table-td"
//                                 colSpan={1}
//                               >
//                                 <div className="print-customsInvoice-txt6">
//                                   {index + 21}
//                                 </div>
//                               </td>
//                               <td
//                                 className="print-invoice-table-td"
//                                 colSpan={2}
//                               >
//                                 <div className="print-customsInvoice-txt6">
//                                   {items.item}
//                                 </div>
//                               </td>
//                               <td
//                                 className="print-invoice-table-td"
//                                 colSpan={1}
//                               >
//                                 <div className="print-customsInvoice-txt6">
//                                   {items.quantity}
//                                 </div>
//                               </td>
//                             </tr>
//                           );
//                         })}
//                     </table>
//                   </div>
//                   <div className="print-invoice-table-column">
//                     <table className="print-invoice-table">
//                       <tr>
//                         <th className="print-invoice-table-td" colSpan={1}>
//                           <div className="print-customsInvoice-txt5">S No</div>
//                         </th>
//                         <th className="print-invoice-table-td" colSpan={2}>
//                           <div className="print-customsInvoice-txt5">
//                             Items Name
//                           </div>
//                         </th>
//                         <th className="print-invoice-table-td" colSpan={1}>
//                           <div className="print-customsInvoice-txt5">Qty</div>
//                         </th>
//                       </tr>
//                       {boxItems &&
//                         boxItems.slice(20).map((items, index) => {
//                           return (
//                             <tr key={index}>
//                               <td
//                                 className="print-invoice-table-td"
//                                 colSpan={1}
//                               >
//                                 <div className="print-customsInvoice-txt6">
//                                   {index + 36}
//                                 </div>
//                               </td>
//                               <td
//                                 className="print-invoice-table-td"
//                                 colSpan={2}
//                               >
//                                 <div className="print-customsInvoice-txt6"></div>
//                               </td>
//                               <td
//                                 className="print-invoice-table-td"
//                                 colSpan={1}
//                               >
//                                 <div className="print-customsInvoice-txt6"></div>
//                               </td>
//                             </tr>
//                           );
//                         })}
//                     </table>
//                   </div>
//                 </div>
//                 <br />
//               </div>
//             ) : null}
//           </div>

//           <Row>
//             <Col sm="6"></Col>
//             <Col sm="3">
//               <Button onClick={() => props.onClose()} block size="large">
//                 Cancel
//               </Button>
//             </Col>
//             <Col sm="3">
//               <ReactToPrint
//                 trigger={() => (
//                   <Button
//                     type="primary"
//                     size="large"
//                     block
//                     onClickCapture={() => {
//                       isPrinted();
//                     }}
//                   >
//                     Print
//                   </Button>
//                 )}
//                 content={() => componentRef.current}
//               />
//             </Col>
//           </Row>
//         </div>
//       )}
//     </Modal>
//   );
// }
// export default PrintCustomerInvoiceModal2;

import { Button, Modal, message } from "antd";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import ReactToPrint from "react-to-print";
import logo from "../../Assets/Images/logoNew.jpg";
import Companyseal from "../../Assets/Images/seal.JPG";
import LoadingBox from "../../Components/LoadingBox";
import { API, Headers } from "../../Config";
import "./style.css";

function PrintCustomerInvoiceModal2(props) {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [boxItems, setBoxItems] = useState([]);
  const componentRef = useRef();

  useEffect(() => {
    loadDetails();
    if (props?.item?.box_number) {
      loaddata(props?.item?.box_number);
    }
  }, []);

  const loadDetails = () => {
    setBoxItems(props.item.boxe_item);
  };

  const medianBoxNum = Math.floor(boxItems && boxItems.length / 2);

  let requestData = {
    is_customer_invoice_print: true,
  };
  const isPrinted = () => {
    axios({
      method: "put",
      url:
        API.BASR_URL +
        API.BOXES_ACTIONS +
        "print/" +
        props.item.box_number +
        "/is_customer_invoice_print",
      headers: Headers(),
      data: requestData,
    })
      .then(function (response) {
        setLoading(false);
        if ([200, 201].includes(response.status)) {
          message.success("Success");
          props.onClose();
          props.reload();
        }
      })
      .catch(function (error) {
        setLoading(false);
        message.error("Oops.Something went wrong");
        console.log(error);
      });
  };

  const loaddata = (id) => {
    axios
      .get(API.BASR_URL + API.BOXES_ACTIONS_BY_BOX_NUMBER + `${id}`, {
        headers: Headers(),
      })
      .then(function (response) {
        if (response?.data) {
          setData(response?.data);
          message.success("Success");
        } else {
          message.error("Oops.Something went wrong");
        }
        setLoading(false);
      })
      .catch(function (error) {
        message.error(error || "Oops.Something went wrong");
      });
  };
  return (
    <Modal
      visible={props.visible}
      onOk={() => props.onClose()}
      onCancel={() => props.onClose()}
      width={900}
      footer={null}
    >
      {loading ? (
        <LoadingBox />
      ) : (
        <div>
          <div ref={componentRef}>
            <div
              className="print-invoice-page"
              style={{
                padding: "20px",
                margin: "0 auto",
                maxWidth: "100%",
                width: "100%",
                overflow: "visible",
              }}
            >
              <table
                className="print-invoice-table"
                style={{
                  width: "100%",
                  margin: "0 auto",
                  tableLayout: "auto",
                }}
              >
                <tr>
                  <td colSpan={2}>
                    <img src={logo} width="" className="InvoiceLogo" />
                  </td>
                  <td></td>
                  <td colSpan={2}>
                    <div className="print-invoice-table-headertxt">
                      <div
                        className="print-invoice-table-headertxt1"
                        style={{ fontSize: "10px", textTransform: "uppercase" }}
                      >
                        HO:
                        {props.item.created_user &&
                        props.item.created_user.branch
                          ? `${
                              (props.item.created_user.branch?.name,
                              props.item.created_user.branch?.office_address)
                            }`
                          : null}
                      </div>
                      <div
                        className="print-invoice-table-headertxt1"
                        style={{ fontSize: "10px" }}
                      >
                        PH:
                        {props.item.created_user &&
                        props.item.created_user.branch
                          ? `${props.item.created_user.branch?.mobile}`
                          : null}
                      </div>
                      <div
                        className="print-invoice-table-headertxt1"
                        style={{ fontSize: "10px" }}
                      >
                        INVOICE DATE:{" "}
                        {props?.item?.createdAt &&
                          moment(props.item?.createdAt).format("DD-MM-YYYY")}
                      </div>
                      <div
                        className="print-invoice-table-headertxt1"
                        style={{ fontSize: "10px" }}
                      >
                        BOOKED STAFF:{" "}
                        {props.item.created_user &&
                          props.item.created_user.name}
                      </div>
                      <div
                        className="print-invoice-table-headertxt1"
                        style={{ fontSize: "10px" }}
                      >
                        BOOKED BRANCH:{" "}
                        {props.item.created_user &&
                          props.item.created_user.branch &&
                          props.item.created_user.branch.name}
                      </div>
                      <div
                        className="print-invoice-table-headertxt1"
                        style={{ fontSize: "10px" }}
                      >
                        BOOKED DATE:{" "}
                        {props.item?.createdAt &&
                          moment(props.item?.createdAt).format("DD-MM-YYYY")}
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan={5}>
                    <div className="print-invoice-txt4">CUSTOMER INVOICE</div>
                  </td>
                </tr>
                <tr>
                  <td colSpan={5}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        gap: "30px",
                      }}
                    >
                      {/* Sender Info - Left Side */}
                      <div
                        style={{
                          width: "48%",
                          padding: "20px",
                        }}
                      >
                        <div
                          className="print-invoice-txt1"
                          style={{
                            fontWeight: "bold",
                            marginBottom: "6px",
                            fontSize: "16px",
                            color: "#2c3e50",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          SENDER INFO
                        </div>
                        <div
                          className="print-invoice-txt2"
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            lineHeight: "1",
                            color: "#34495e",
                          }}
                        >
                          <strong
                            style={{
                              color: "#2c3e50",
                              minWidth: "60px",
                              display: "inline-block",
                            }}
                          >
                            Name:
                          </strong>{" "}
                          {props.item.collection &&
                            props.item.collection.sender_name}
                        </div>
                        <div
                          className="print-invoice-txt2"
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            lineHeight: "1",
                            color: "#34495e",
                          }}
                        >
                          <strong
                            style={{
                              color: "#2c3e50",
                              minWidth: "60px",
                              display: "inline-block",
                            }}
                          >
                            Address:
                          </strong>{" "}
                          {props.item.collection &&
                            props.item.collection.sender_address}
                        </div>
                      </div>

                      {/* Receiver Info - Right Side */}
                      <div
                        style={{
                          width: "48%",
                          padding: "20px",
                        }}
                      >
                        <div
                          className="print-invoice-txt1"
                          style={{
                            fontWeight: "bold",
                            marginBottom: "6px",
                            fontSize: "16px",
                            color: "#2c3e50",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          RECEIVER INFO
                        </div>
                        <div
                          className="print-invoice-txt2"
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            lineHeight: "1",
                            color: "#34495e",
                          }}
                        >
                          <strong
                            style={{
                              color: "#2c3e50",
                              minWidth: "60px",
                              display: "inline-block",
                            }}
                          >
                            Name:
                          </strong>{" "}
                          {props.item.collection &&
                            props.item.collection.reciver_name}
                        </div>
                        <div
                          className="print-invoice-txt2"
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            lineHeight: "1",
                            color: "#34495e",
                          }}
                        >
                          <strong
                            style={{
                              color: "#2c3e50",
                              minWidth: "60px",
                              display: "inline-block",
                            }}
                          >
                            Address:
                          </strong>{" "}
                          {props.item.collection &&
                            props.item.collection.reciver_address}
                        </div>
                        <div
                          className="print-invoice-txt2"
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            lineHeight: "1",
                            color: "#34495e",
                          }}
                        >
                          <strong
                            style={{
                              color: "#2c3e50",
                              minWidth: "60px",
                              display: "inline-block",
                            }}
                          >
                            Phone:
                          </strong>{" "}
                          {props.item.collection &&
                            props.item.collection.reciver_phone}
                          {props.item.collection &&
                            props.item.collection.reciver_altphone &&
                            `, ${props.item.collection.reciver_altphone}`}
                        </div>
                        <div
                          className="print-invoice-txt2"
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            lineHeight: "1",
                            color: "#34495e",
                          }}
                        >
                          <strong
                            style={{
                              color: "#2c3e50",
                              minWidth: "60px",
                              display: "inline-block",
                            }}
                          >
                            Location:
                          </strong>{" "}
                          {props.item.collection &&
                            props.item.collection.reciver_pincode}
                          {props.item.collection &&
                            props.item.collection.reciver_city &&
                            `, ${props.item.collection.reciver_city}`}
                          {props.item.collection?.reciver_post && (
                            <div
                              className="print-invoices-text3"
                              style={{
                                marginTop: "4px",
                                fontSize: "11px",
                                color: "#666",
                              }}
                            >
                              Post: {props.item.collection.reciver_post}
                            </div>
                          )}
                        </div>
                        <div
                          className="print-invoice-txt2"
                          style={{
                            marginBottom: "12px",
                            fontSize: "13px",
                            lineHeight: "1",
                            color: "#34495e",
                          }}
                        >
                          <strong
                            style={{
                              color: "#2c3e50",
                              minWidth: "60px",
                              display: "inline-block",
                            }}
                          >
                            Region:
                          </strong>{" "}
                          {props.item.collection &&
                            props.item.collection.reciver_distrcit}
                          {props.item.collection &&
                            props.item.collection.reciver_state &&
                            `, ${props.item.collection.reciver_state}`}
                          {props.item.collection &&
                            props.item.collection.recivercountries &&
                            props.item.collection.recivercountries.name &&
                            `, ${props.item.collection.recivercountries.name}`}
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td colSpan={5}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "20px 0",
                        // margin: "15px 0",
                        backgroundColor: "#f8f9fa",
                        borderRadius: "8px",
                        paddingLeft: "15px",
                        paddingRight: "15px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "30px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{ fontWeight: "500", fontSize: "14px" }}>
                            Booking No :
                          </span>
                          <span style={{ fontSize: "14px", fontWeight: "600" }}>
                            {props.item && props?.item?.collection_id}
                          </span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{ fontWeight: "500", fontSize: "14px" }}>
                            Total Pieces:
                          </span>
                          <span style={{ fontSize: "14px", fontWeight: "600" }}>
                            {data && data?.boxes
                              ? data.boxes.length
                              : props.item?.collection?.boxes?.length || 0}
                          </span>
                        </div>

                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{ fontWeight: "500", fontSize: "14px" }}>
                            Total Weight :
                          </span>
                          <span style={{ fontSize: "14px", fontWeight: "600" }}>
                            {" "}
                            {data && data?.boxes
                              ? data.boxes
                                  .reduce(
                                    (sum, box) =>
                                      sum +
                                      (parseFloat(box.chargable_weight) || 0),
                                    0
                                  )
                                  .toFixed(2)
                              : "0.00"}{" "}
                            kg
                          </span>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <span style={{ fontWeight: "500", fontSize: "14px" }}>
                            Service:
                          </span>
                          <span style={{ fontSize: "14px", fontWeight: "700" }}>
                            {props.item.service &&
                              props.item.service.name &&
                              props.item.service.name}
                          </span>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
                <br />
                <tr>
                  <td colSpan={5}>
                    <div className="print-invoice-txt4">BOXES DETAILS</div>
                  </td>
                </tr>
                <br />
                <tr>
                  <td colSpan={5}>
                    <table
                      className="print-invoice-table"
                      style={{ width: "100%" }}
                    >
                      <tr>
                        <th
                          className="print-invoice-table-td"
                          style={{ width: "25%" }}
                        >
                          <div className="print-customsInvoice-txt5">
                            Box Number
                          </div>
                        </th>
                        <th
                          className="print-invoice-table-td"
                          style={{ width: "40%" }}
                        >
                          <div className="print-customsInvoice-txt5">Items</div>
                        </th>
                        <th
                          className="print-invoice-table-td"
                          style={{ width: "15%" }}
                        >
                          <div className="print-customsInvoice-txt5">
                            Weight
                          </div>
                        </th>
                        <th
                          className="print-invoice-table-td"
                          style={{ width: "20%" }}
                        >
                          <div className="print-customsInvoice-txt5">
                            Service
                          </div>
                        </th>
                      </tr>
                      {data &&
                        data.boxes &&
                        data.boxes.map((box, index) => {
                          // Get all items for this box
                          const boxItems = box.boxitems
                            ? box.boxitems.map((item) => item.item).join(", ")
                            : "";

                          return (
                            <tr key={index}>
                              <td className="print-invoice-table-td">
                                <div className="print-customsInvoice-txt6">
                                  {box.box_number}
                                </div>
                              </td>
                              <td className="print-invoice-table-td">
                                <div className="print-customsInvoice-txt6">
                                  {boxItems}
                                </div>
                              </td>
                              <td className="print-invoice-table-td">
                                <div className="print-customsInvoice-txt6">
                                  {box.chargable_weight}
                                </div>
                              </td>
                              <td className="print-invoice-table-td">
                                <div className="print-customsInvoice-txt6">
                                  {box.service && box.service.name}
                                </div>
                              </td>
                            </tr>
                          );
                        })}

                      {/* Total row */}
                      {data && data?.boxes && data?.boxes?.length > 0 && (
                        <tr
                          style={{
                            backgroundColor: "#f2f2f2",
                            fontWeight: "bold",
                          }}
                        >
                          <td className="print-invoice-table-td">
                            <div className="print-customsInvoice-txt6">
                              Total Weight
                            </div>
                          </td>
                          <td className="print-invoice-table-td">
                            <div className="print-customsInvoice-txt6"></div>
                          </td>
                          <td className="print-invoice-table-td">
                            <div className="print-customsInvoice-txt6">
                              {data.boxes
                                .reduce(
                                  (sum, box) =>
                                    sum +
                                    (parseFloat(box.chargable_weight) || 0),
                                  0
                                )
                                .toFixed(2)}
                            </div>
                          </td>
                          <td className="print-invoice-table-td">
                            <div className="print-customsInvoice-txt6"></div>
                          </td>
                        </tr>
                      )}
                    </table>
                  </td>
                </tr>

                <tr>
                  <td colSpan={5}>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        marginTop: "30px",
                        padding: "20px 0",
                        borderTop: "1px solid #ddd",
                      }}
                    >
                      {/* Sender Signature Section - Left Side */}
                      <div
                        style={{
                          width: "45%",
                          textAlign: "left",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "bold",
                            fontSize: "14px",
                            marginBottom: "15px",
                            color: "#2c3e50",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          Sender Signature
                        </div>
                        <div
                          style={{
                            minHeight: "80px",
                            marginBottom: "5px",
                          }}
                        >
                          {props.item.signature ? (
                            <img
                              src={props.item.signature}
                              className="print-invoice-signature"
                              style={{
                                maxWidth: "150px",
                                maxHeight: "100px",
                                objectFit: "contain",
                              }}
                            />
                          ) : (
                            <div />
                          )}
                        </div>
                      </div>

                      {/* Company Section - Right Side */}
                      <div
                        style={{
                          width: "45%",
                          textAlign: "right",
                        }}
                      >
                        <div
                          style={{
                            fontWeight: "bold",
                            fontSize: "14px",
                            marginBottom: "15px",
                            color: "#2c3e50",
                            textTransform: "uppercase",
                            letterSpacing: "0.5px",
                          }}
                        >
                          For Sahari International Courier
                        </div>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "center",
                            gap: "20px",
                            minHeight: "80px",
                          }}
                        >
                          <img
                            src={Companyseal}
                            style={{
                              maxWidth: "150px",
                              maxHeight: "100px",
                              objectFit: "contain",
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>

          <Row>
            <Col sm="6"></Col>
            <Col sm="3">
              <Button onClick={() => props.onClose()} block size="large">
                Cancel
              </Button>
            </Col>
            <Col sm="3">
              <ReactToPrint
                trigger={() => (
                  <Button
                    type="primary"
                    size="large"
                    block
                    onClickCapture={() => {
                      isPrinted();
                    }}
                  >
                    Print
                  </Button>
                )}
                content={() => componentRef.current}
              />
            </Col>
          </Row>
        </div>
      )}
    </Modal>
  );
}
export default PrintCustomerInvoiceModal2;
